














































































































import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class Curvometer extends Vue {
  // Props
  @Prop(Object) public rec!: object;
  @Prop(Boolean) public isReadOnly!: boolean;

  public parseNumber(n) {
    // Replace all commas to dots and convert string to number
    return n ? Number(n.replace(/,/g, '.')) : n;
  }

  public focusNext(e) {
    const inputs: any = Array.from(
      e.target.form.querySelectorAll('input[type="text"]')
    );
    const index = inputs.indexOf(e.target);

    if (index < inputs.length) {
      inputs[index + 1].focus();
    }
  }

  get rol_avg() {
    const rec: any = this.rec;
    const sum =
      (rec.rol_1 ? this.parseNumber(rec.rol_1) : 0) +
      (rec.rol_2 ? this.parseNumber(rec.rol_2) : 0) +
      (rec.rol_3 ? this.parseNumber(rec.rol_3) : 0);
    return Number((sum / 3).toFixed(3));
  }

  get rol_avg_ok() {
    return this.rol_avg >= 81.16 && this.rol_avg <= 82.16;
  }

  public calculateMin(speed) {
    return this.rol_avg === 0
      ? ''
      : Math.round(
          ((Number(speed) - 0.5) * 1000000) / (Math.PI * this.rol_avg * 60)
        );
  }

  public calculateMax(speed) {
    return this.rol_avg === 0
      ? ''
      : Math.round(
          ((Number(speed) + 0.5) * 1000000) / (Math.PI * this.rol_avg * 60)
        );
  }

  public calculateAverage(speed) {
    const min =
      this.rol_avg === 0
        ? ''
        : ((Number(speed) - 0.5) * 1000000) / (Math.PI * this.rol_avg * 60);
    const max =
      this.rol_avg === 0
        ? ''
        : ((Number(speed) + 0.5) * 1000000) / (Math.PI * this.rol_avg * 60);
    return min && max ? Math.round((min + max) / 2) : '';
  }
}
